// Numéros des poteaux (même règles que le serveur) : séparateurs espace , ; - et plages « 30000 à 30049 » ou « 30000..30049 ».
const MAX_RANGE = 5000;

export function expandPoles(text) {
  let t = String(text || '');
  let error = null;
  t = t.replace(/(\d+)(?:\s*\.\.\s*|\s+(?:à|au|a)\s+)(\d+)/gi, (m, a, b) => {
    const s = Number(a); const e = Number(b);
    if (e < s || e - s + 1 > MAX_RANGE) { error = `Plage invalide : ${a} à ${b}`; return ' '; }
    const w = a.length > 1 && a.startsWith('0') ? a.length : 0;
    const out = [];
    for (let n = s; n <= e; n += 1) out.push(w ? String(n).padStart(w, '0') : String(n));
    return ` ${out.join(' ')} `;
  });
  const list = t.split(/[\s,;\-–]+/).map((x) => x.trim()).filter(Boolean);
  const seen = new Set();
  const dups = [...new Set(list.filter((n) => (seen.has(n) ? true : (seen.add(n), false))))];
  return { list, dups, error };
}

/** « 30000 à 30049, 30060 » */
export function compactPoles(list) {
  const out = [];
  const isNum = (s) => /^\d+$/.test(s);
  let i = 0;
  while (i < list.length) {
    let j = i;
    while (j + 1 < list.length && isNum(list[j]) && isNum(list[j + 1])
      && Number(list[j + 1]) === Number(list[j]) + 1 && list[j + 1].length === list[j].length) j += 1;
    out.push(j - i >= 2 ? `${list[i]} à ${list[j]}` : list.slice(i, j + 1).join(', '));
    i = j + 1;
  }
  return out.join(', ');
}
